export default __webpack_public_path__ + "static/media/helicopter.f6380b8e.ogg";